/**
 * Backend block type ↔ TipTap node name for the "advanced" atom blocks whose
 * node attrs are exactly the block data. A type missing from this map degrades
 * silently (placeholder on load, dropped on save), so both directions derive
 * from the same table.
 */
export const ADVANCED_BLOCK_NODES: Record<string, string> = {
    timeline: 'timelineBlock',
    pdf_viewer: 'pdfViewerBlock',
    hotspot: 'hotspotBlock',
    labeling: 'labelingBlock',
    h5p: 'h5pBlock',
    code_sandbox: 'codeSandboxBlock',
    branching: 'branchingBlock',
    simulation: 'simulationBlock',
    photo_task: 'photoTaskBlock',
    slider_scale: 'sliderScaleBlock',
    sorting: 'sortingBlock',
    discussion: 'discussionBlock',
    scorm_embed: 'scormEmbedBlock',
};

export const NODE_TO_ADVANCED_BLOCK: Record<string, string> = Object.fromEntries(
    Object.entries(ADVANCED_BLOCK_NODES).map(([type, node]) => [node, type]),
);
